import { NgModule } from '@angular/core';
import { PipesModule } from '@element451-libs/utils451/pipes';

@NgModule({
  exports: [PipesModule],
  imports: [PipesModule]
})
export class Page451ComponentsSharedModule {}
